<vs-app-page
  *vsLet="((table?.paginationConfig$ | async)?.totalItems ?? null) as totalClaims"
  [config]="{
    icon: 'file-06',
    title: 'Claims',
    showDivider: true,
    description: 'This is an overview of all claims filed across your organization.'
  }"
>
  <vs-breadcrumbs slot="breadcrumbs" [config]="{ items: [{ label: 'Claims' }] }"></vs-breadcrumbs>

  <vs-badge
    *vsLet="(totalClaims ?? null) as totalClaims"
    slot="title-end"
    [class.italic]="totalClaims === null"
    [class.animate-pulse]="totalClaims === null"
  >
    {{totalClaims === null ? 'loading' : (totalClaims | number) + ' ' + (totalClaims === 1 ? 'Claim' : 'Claims')}}
  </vs-badge>

  <div *ngIf="totalClaims" slot="header-end" class="flex flex-col items-end gap-2 max-w-full sm:max-w-min">
    <button
      *ngIf="canOpenClaim$ | async"
      vs-button
      theme="primary"
      class="flex-grow"
      [disabled]="isWarrantyIneligible(selectedWarranty)"
      [class.opacity-60]="isWarrantyIneligible(selectedWarranty)"
      [class.cursor-not-allowed]="isWarrantyIneligible(selectedWarranty)"
      [attr.aria-disabled]="isWarrantyIneligible(selectedWarranty) ? true : null"
      (click)="openClaim()"
    >
      <vs-icon name="plus"></vs-icon> New Claim
    </button>

    <div
      *ngIf="isWarrantyIneligible(selectedWarranty)"
      class="flex items-center gap-2 text-info-700 max-w-[320px] text-right"
    >
      <vs-icon [name]="warrantyIneligibleIcon(selectedWarranty)" size="16"></vs-icon>
      <p class="text-xs font-medium">{{ warrantyIneligibleMessage(selectedWarranty) }}</p>
    </div>
  </div>

  <ws-claims-table #table [warranty]="selectedWarranty"></ws-claims-table>

  <ws-open-claim-dialog
    #openClaimDialog
    [warranty]="selectedWarranty"
    [customer]="selectedWarranty?.customer"
    (closed)="table.closeClaimDialog()"
  ></ws-open-claim-dialog>
</vs-app-page>
